export enum BetaalbaarheidEnum {
  SOCIALE_HUUR = 'Sociale huur',
  HUUR_MIDDENHUUR = 'Huur middenhuur',
  HUUR_DURE_HUUR = 'Huur dure huur',
  HUUR_ONBEKEND = 'Huur onbekend',
  KOOP_BETAALBARE_KOOP = 'Koop betaalbare koop',
  KOOP_DURE_KOOP = 'Koop dure koop',
  KOOP_ONBEKEND = 'Koop onbekend',
  ONBEKEND_KOOP_OF_HUUR = 'Onbekend koop of huur',
}
